import React from 'react';
import { Doughnut } from 'react-chartjs-2';

const PaymentStatusChart = ({ data }) => {
    if (!data || !data.totals) return null;

    const t = data.totals;
    const chartData = {
        labels: [
            `Paid (${t.paid_count} orders)`,
            `Unpaid (${t.unpaid_count} orders)`,
            `Partial (${t.partial_count} orders)`,
        ],
        datasets: [{
            data: [t.paid_amount, t.unpaid_amount, t.partial_amount],
            backgroundColor: ['#10B981', '#EF4444', '#F59E0B'],
            borderWidth: 1,
        }],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { position: 'bottom', labels: { boxWidth: 12, padding: 8, font: { size: 11 } } },
        },
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Payment Status Breakdown</h6>
                <Doughnut data={chartData} options={options} />
                <div className="row mt-3 text-center g-2">
                    <div className="col-4">
                        <small className="text-muted d-block">Paid</small>
                        <strong className="text-success">{t.paid_amount?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                    </div>
                    <div className="col-4">
                        <small className="text-muted d-block">Unpaid</small>
                        <strong className="text-danger">{t.unpaid_amount?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                    </div>
                    <div className="col-4">
                        <small className="text-muted d-block">Partial</small>
                        <strong className="text-warning">{t.partial_amount?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentStatusChart;
